<template>
  <div>
    <div class="grid-header-container">
      <router-link style="display: inline-block; white-space: nowrap" to="/samples/">
        <i class="material-icons material-icon--16 no-text-decoration">keyboard_backspace</i>
        Samples
      </router-link>

      <span style="display: block; color: #00000066; text-align: center">
        <i class="material-icons material-icon--14">opacity</i>
        Create a New Sample
      </span>
    </div>

    <SampleNewComponent style="margin-top: 16px" />
  </div>
</template>

<script>
  import 'assets/css/component/new-sam-cal-seq.scss';
  import PageTitle from '@/mixins/page-title';
  import SampleNewComponent from 'components/block/SampleNewComponent';

  export default {
    name: 'SampleNewPage',

    components: {
      SampleNewComponent,
    },

    mixins: [PageTitle],

    data: () => ({
      pageTitle: 'HPLC Cloud: New Sample',
    }),
  };
</script>
